import axios from "axios"

async function getServiceWorkerVersion() {
  const res = await axios({
    url: `/version.json?&timestamp=${new Date().getTime()}`, //your url
    method: 'GET',
    responseType: 'json',
    headers: {
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': '0',
    },
  })
  return res.data.version
}

export async function checkServiceWorkerVersion() {
  const requiredVersion = await getServiceWorkerVersion()
  const currentVersion = import.meta.env.VUE_APP_VERSION

  if (requiredVersion !== currentVersion) {
    return false
    // await store.dispatch('app/setIsNewVersionAvailable', true)
  }
  return true
}

export async function refreshServiceWorker() {
  try {
    const registrations = await navigator.serviceWorker.getRegistrations()
    for (const registration of registrations) {
      await registration.unregister();
    }
  } catch (e) {
    console.log('e', e)
  } finally {
    window.location.reload()
  }
}
